import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import useOpenConferenceCall from 'features/ConferenceCall/hooks/useConferenceCall'
import { Message, MessageType } from 'lib/_types'

type Props = {
  message: Message
}

const ALLOWED_TYPE: Readonly<MessageType[]> = ['call', 'individual_call']

export const ChatMessageCall = ({ message }: Props) => {
  if (!ALLOWED_TYPE.includes(message?.message_type)) return null

  const { t } = useTranslation()
  const { openConferenceCall } = useOpenConferenceCall()

  const isActive = message.conference_call?.active ?? false

  const className = `Messages__item__${
    message.conference_call?.call_type === 'vdo' ? 'video' : 'voice'
  }_call`

  return (
    <div
      className={cx(className, {
        [`${className}--active`]: isActive,
      })}
      onClick={() => {
        if (isActive) {
          openConferenceCall({
            conferenceCallId: message.conference_call?.id?.toString?.(),
            targetId: message.room_id?.toString?.(),
          })
        }
      }}
    >
      {isActive
        ? t('chatroom.chat_message.call.active')
        : t('chatroom.chat_message.call.inactive')}
    </div>
  )
}
